<ng-container *ngIf="selectedSchool">
  {{ selectedSchool.title }}
</ng-container>
